import { Link, Popover, TableProps } from '@amzn/awsui-components-core';
import React from 'react';
import {
  ContentEngagement,
  ContentEngagementType,
} from '@amzn/awscat-pattern-library-service-model';
import { stringComparator } from '../utils/Comparator';

export const DEFAULT_PAGE_SIZE_OPTIONS = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
];

const MAX_NOTES_LENGTH = 20;

export const engagementColumnDefinitions: Array<TableProps.ColumnDefinition<ContentEngagement>> = [
  {
    cell: (i: ContentEngagement) => getEngagementType(i),
    header: 'Type',
    id: 'type',
    sortingComparator: stringComparator((i) => getEngagementType(i)),
  },
  {
    cell: (i: ContentEngagement) => `${i.userName} (${i.userId})`,
    header: 'Submitted by',
    id: 'submittedBy',
    sortingComparator: stringComparator((i) => `${i.userName} (${i.userId})`),
  },
  {
    cell: (i: ContentEngagement) => i.salesforceId,
    header: 'Salesforce ID',
    id: 'salesforceId',
    sortingComparator: stringComparator((i) => i.salesforceId),
  },
  {
    cell: (i: ContentEngagement) =>
      i.notes?.length > MAX_NOTES_LENGTH ? getNotesColumnValue(i.notes) : i.notes,
    header: 'Notes',
    id: 'notes',
  },
];

export const engagementCsvFormat: Array<{ header: string; value: (e: ContentEngagement) => any }> =
  [
    {
      header: 'Type',
      value: (i) => getEngagementType(i),
    },
    {
      header: 'Submitted by',
      value: (i) => `${i.userName} (${i.userId})`,
    },
    {
      header: 'Salesforce ID',
      value: (i) => i.salesforceId,
    },
    {
      header: 'Notes',
      value: (i) => i.notes,
    },
  ];

const getEngagementType = (e: ContentEngagement) => {
  return e.engagementType || ContentEngagementType.Project;
};

const getNotesColumnValue = (notes: string) => {
  return (
    <div>
      {notes.substring(0, MAX_NOTES_LENGTH)}...&nbsp;
      <Popover size="large" triggerType="custom" dismissButton={false} content={notes}>
        <Link variant="secondary">More</Link>
      </Popover>
    </div>
  );
};
